import {
  LISTINGS_FETCH_DATA_SUCCESS,
  LISTINGS_HAS_ERRORED,
  SET_OVERFILTERED_TIMESTAMP,
  SET_OVERFILTERED_BANNER_TEXT,
  LISTINGS_IS_LOADING,
  DISPLAY_INFINITE_SCROLL_LOAD_MORE,
  LISTINGS_LOADING_MESSAGE,
  FETCHED_INITIAL_LISTINGS,
  LISTINGS_LOAD_MORE_SUCCESS,
  SET_EXPIRED_SESSION_TIMESTAMP,
  UPDATE_BRAND_REFERENCE,
  UPDATE_ACTIVE_TAB_ID,
  SET_LISTINGS_META_DATA,
} from '../actionTypes'

export function listingsIsLoading(isLoading) {
  return {
    type: LISTINGS_IS_LOADING,
    isLoading,
  }
}

/**
 * Set the META information for Listings App
 * */
export function setListingsMetaData(meta) {
  return {
    type: SET_LISTINGS_META_DATA,
    meta,
  }
}

/**
 * Set timestamp to current time on app load and when filters change. This represents the start time
 * of the timeout that determines when to show the <SearchRefreshOverlay/>.
 * @returns {{type: string}}
 */
export function setExpiredSessionTimestamp() {
  return {
    type: SET_EXPIRED_SESSION_TIMESTAMP,
  }
}

export function listingsLoadingMessage(message) {
  return {
    type: LISTINGS_LOADING_MESSAGE,
    message,
  }
}

export function listingsHasErrored(hasErrored) {
  return {
    type: LISTINGS_HAS_ERRORED,
    hasErrored,
  }
}

export function setOverfilteredBannerText(setAttributeText) {
  return {
    type: SET_OVERFILTERED_BANNER_TEXT,
    setAttributeText,
  }
}

export function setOverfilteredStatus(hasOverfiltered) {
  return {
    type: SET_OVERFILTERED_TIMESTAMP,
    overFilteredTimeStamp: hasOverfiltered ? new Date().getTime() : null,
  }
}

export function listingsFetchDataSuccess(listings) {
  return {
    type: LISTINGS_FETCH_DATA_SUCCESS,
    listings,
  }
}

export function listingsLoadMoreSuccess(listings) {
  return {
    type: LISTINGS_LOAD_MORE_SUCCESS,
    listings,
  }
}

export function displayInfiniteScrollLoadMore(bool) {
  return {
    type: DISPLAY_INFINITE_SCROLL_LOAD_MORE,
    bool,
  }
}

export function fetchedInitialListings(bool) {
  return {
    type: FETCHED_INITIAL_LISTINGS,
    bool,
  }
}

export function updateBrandReference(brandReference) {
  return {
    type: UPDATE_BRAND_REFERENCE,
    brandReference,
  }
}

export const updateActiveTabId = activeTabId => {
  return {
    type: UPDATE_ACTIVE_TAB_ID,
    activeTabId,
  }
}
